import React from 'react';
import Paper from '@material-ui/core/Paper';
import { t } from 'ttag';

import { useMutation } from '@apollo/react-hooks';
import DataTable from '../../../components/DataTable';
import useApi from '../../../api';
import useDataList from '../../../hooks/useDataList';
import useNotifier from '../../../components/Messages/hooks';

const getPostData = (row) => ({
  userId: row.userId || '',
  fullName: row.fullName || '',
  type: row.type || '',
  email: row.email || null,
  phone: row.phone || '',
});

const ParentListView = ({ userId }) => {
  const pushMessage = useNotifier();
  const api = useApi();
  const schema = api.schema.parents;
  const [createMutation, createKey] = schema.create();
  const [updateMutation, updateKey] = schema.update();
  const [deleteMutation, deleteKey] = schema.delete();
  const { data, loading, refetch } = useDataList({
    schema: api.schema.parents,
    router: api.router.parents,
    variables: { userId },
  });
  const handleOnCreateComplete = (d) => {
    const res = d[createKey];
    if (res.ok) {
      pushMessage({ text: t`Успішно додано` });
      refetch();
    } else {
      pushMessage({ text: t`Виникла помилка` });
    }
  };
  const handleOnEditComplete = (d) => {
    const res = d[updateKey];
    if (res.ok) {
      pushMessage({ text: t`Успішно змінено` });
      refetch();
    } else {
      pushMessage({ text: t`Виникла помилка` });
    }
  };

  const handleOnDelete = (d) => {
    const res = d[deleteKey];
    if (res.ok) {
      pushMessage({ text: t`Успішно видалено` });
      refetch();
    } else {
      pushMessage({ text: t`Виникла помилка` });
    }
  };

  const [doCreate] = useMutation(createMutation, {
    onCompleted: handleOnCreateComplete,
  });

  const [doUpdate] = useMutation(updateMutation, {
    onCompleted: handleOnEditComplete,
  });

  const [doDelete] = useMutation(deleteMutation, {
    onCompleted: handleOnDelete,
  });

  const columns = [
    { title: t`Назва родича`, field: 'type' },
    { title: t`ПІБ`, field: 'fullName' },
    { title: t`Телефон`, field: 'phone' },
    { title: t`Email`, field: 'email' },
  ];

  return (
    <Paper>
      <DataTable
        pageSize={5}
        isLoading={loading}
        title={t`Список родичів`}
        columns={columns}
        data={data || []}
        onAdd={(formData) =>
          doCreate({
            variables: { inputData: getPostData({ userId, ...formData }) },
          })
        }
        onEdit={(formData) =>
          doUpdate({
            variables: {
              id: formData.id,
              inputData: getPostData({ userId, ...formData }),
            },
          })
        }
        onDelete={(formData) => doDelete({ variables: { id: formData.id } })}
        isEditable
      />
    </Paper>
  );
};

export default ParentListView;
